var generic = generic || {};
var site = site || {};

var slidedownVideoPlayer = {
  createVideoPlayerDiv: function($elem, i) {
    var id = $elem.attr('class') + '-' + i;
    $elem
      .parent()
      .append('<div />')
      .children('div')
      .attr('id', id);
    $elem.remove(); // Remove the placeholder element
    return id;
  },

  addVideo: function(ytId, iframeId) {
    /*global YT */
    var player = new YT.Player(iframeId, {
      height: '100%',
      width: '100%',
      videoId: ytId,
      playerVars: {
        controls: 1,
        showinfo: 0,
        rel: 0
      },
      events: {
        'onReady': function(event) {
          // Detect mobile
          // Taken from - http://stackoverflow.com/a/13819253
          var isMobile = {
            Android: function() {
              return navigator.userAgent.match(/Android/i);
            },
            BlackBerry: function() {
              return navigator.userAgent.match(/BlackBerry/i);
            },
            iOS: function() {
              return navigator.userAgent.match(/iPhone|iPad|iPod/i);
            },
            Opera: function() {
              return navigator.userAgent.match(/Opera Mini/i);
            },
            Windows: function() {
              return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
            },
            any: function() {
              return isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows();
            }
          };
          // Don't autoplay on any mobile device
          if (!isMobile.any()) {
            event.target.playVideo();
          }
        }
      }
    });
  },

  setup: function(event, $player) {
    var self = this;

    $player.each(function() {
      var $me = $(this);
      var $content = $('.slidedown-video-player__content', $me);
      var $vids = $content.filter(function() {
        return $(this).data('video-provider') === 'youtube' && $(this).data('youtube-id').length > 0;
      });
      var $playIcon = $('.slidedown-video-player__media .js-play, .js-slidedown-video-cta', $content);
      var $playIconBtn = $('i.js-play', $content);

      $vids.each(function() {
        var $wrap = $(this);
        var ytId = $wrap.attr('data-youtube-id');

        $playIcon.keydown(function(e) {
          if (site.getKeycode(e) === 13) {
            $playIcon.trigger('click');
          }
        });

        $playIcon.click(function(e) {
          // Do something useless
          e.preventDefault();

          if ($playIconBtn.length) {
            $playIconBtn.addClass('hidden');
          }

          // Save scroll position, the colorbox causes a jump
          var scrollPosition = $(window).scrollTop();

          // Detect if we want an inverted colored close icon or not
          var classList = (function() {
            if ($wrap.hasClass('js-invert-close')) {
              return 'overlay--slidedown-video inverted-close';
            }
            return 'overlay--slidedown-video';
          })();

          if ($wrap.hasClass('js-play-within-frame')) {
            var videoContainer = $wrap.find('.js-slidedown-video-placeholder');
            // Create a new div for the player to take over inside of the colorbox
            var iframeId = self.createVideoPlayerDiv(videoContainer, Math.floor(+new Date()) / 1000);

            // Instantiate the video
            self.addVideo(ytId, iframeId);
          } else {
            // Launch the overlay
            generic.overlay.launch({
              content: '<div class="js-slidedown-video-placeholder"></div>', // Empty div for selection that gets removed
              transition: 'none',
              fixed: 'true',
              appearDuration: 1.0,
              opacity: 0,
              maxWidth: '100%',
              maxHeight: '100%',
              overflow: 'hidden',
              cssStyle: {
                border: 'none',
                padding: 0,
                backgroundColor: '#000',
                height: '100%',
                width: '100%',
                position: 'fixed',
                className: classList,
                onComplete: function() {
                  var _this = this;
                  _this.$cbox = $('#colorbox.overlay--slidedown-video');

                  // Create a new div for the player to take over inside of the colorbox
                  var iframeId = self.createVideoPlayerDiv($('.js-slidedown-video-placeholder', _this.$cbox), Math.floor(+new Date()) / 1000);

                  // Instantiate the video
                  self.addVideo(ytId, iframeId);

                  // Animate in
                  _this.$cbox.addClass('active');

                  // Hide overflow on the body
                  setTimeout(function() {
                    $('body').css({
                      overflow: 'hidden',
                      height: $(window).height()
                    });
                  }, 1000);
                },
                onCleanup: function() {
                  var _this = this;
                  _this.$cbox.removeClass('active');

                  $('body').css({
                    overflow: '',
                    height: ''
                  });
                  $(window).scrollTop(scrollPosition);
                }
              }
            });
          }
          // Make responsive
          $(window).off('resize.slidedownVideoResize').on('resize.slidedownVideoResize', function() {
            $.colorbox.resize({
              width: '100%',
              height: '100%'
            });
          });

          // Do something else that's useless
          return false;
        });
      });
    });
  }
};
